export default {
    profile: 'Perfil',
    home:'Início',
    about_us:'Sobre nós',
    frequent_questions:'Dúvidas Frequentes',
    booking_history:'Histórico de corridas',
    logout:'Sair',
    notification_title:'Notificação Ambulancia',
    select_reason:'Selecione um razão de cancelamento',
    no_cancel_reason:'Sem razões de cancelamento',
    ok:'Ok',
    cancel:'Cancelar',
    select_country:'Escolha Seu País',
    google_places_error:'Place ID to Location Error',
    not_valid_rider:'Esse login é inválido, não é um passageiro',
    new_booking_msg:'Você tem uma nova solicitação de corrida',
    no_driver:'Nenhum Motorista Encontrado',
    no_bookings:'Sem corridas disponíveis',
    booking_cancelled:'Corrida Cancelada. ID : ',
    no_cars:'Sem carros Disponíveis:',
    no_route:'Rota não encontrada.',
    firstname:'Nome',
    lastname:'Sobrenome',
    email:'Email',
    phone:'Número de telefone',
    password:'Senha',
    otp:'OTP',
    profile_updated:'Perfil atualizado.',
    proper_email:'Por favor insira seu email corretamente.',
    submit:'Enviar',
    booking_title:'Minhas Corridas',
    booking_id:'ID da corrida',
    booking_date: 'Data da corrida',
    car_type: 'Modalidade',
    pickup_address :'Endereço de ínicio da corrida',
    drop_address: 'Endereço final da corrida',
    booking_status: 'Status da corrida',
    trip_cost:'Custo da corrida',
    payment_status:'Status do pagamento',
    cancel_booking:'Cancelar Corrida',
    select_car:'Modalidade da Corrida',
    select_booking_type:'Selecione o tipo de corrida',
    book_now: 'Peça agora',
    book_later: 'Agendar Corrida',
    book: 'Corrida',
    select_proper:'Por favor, selecione corretamente',
    must_login:'Por favor, faça login para continuar',
    pickup_location:'Onde começa sua corrida?',
    drop_location:'Para onde quer ir?',
    booking_success:'Sucesso. Id da Corrida : ',
    myaccount: 'Minha Conta',
    login_signup: 'Login / Cadastro',
    login_success:'Logado com sucesso. Precisamos que complete o cadastro',
    login_validate_error:'Email ou senha incorretos',
    otp_validate_error:'OTP não válido',
    reset_pass_msg:'Redefinir senha, enviar email.',
    signin:'Entrar',
    login:'Logar',
    register:'Cadastrar',
    get_otp:'Obter OTP',
    verify_otp:'Verificar OTP',
    complete_registration:'Cadastro Completo',
    forgot_pass_title:'Esqueci minha senha',
    forgot_pass_description:'Preencha seu endereço de e-mail e solicite. Um link será enviado para sua caixa de email.',
    reset_password:'Redefinir senha',
    email_tab:'Login por email',
    phone_tab:'Login por celular',
    booking_date_time:'Tempo de corrida',
    past_booking_error:'O passegeiro posterior não está disponível para data e hora passada ou dentro dos próximos 15 minutos.',
    booking_taken:'Reserva concluída. O motorista sera atribuído 15 minutos antes do horário de reserva. O ID da sua corrida é : ',
    settings_error: 'Erro ao atualizar configurações.',
    estimate:'Tarifa estimada',
    auth_error:'Alerta de autenticação',
    email_verify_message:'Por favor verifique seu email, mensagem já enviada para sua caixa de entrada'
}